<template>
  <div class="about-area">
    <div class="container">
      <!-- Trending Tittle -->
      <div class="row">
        <div class="col-lg-12">
          <div class="trending-tittle"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <!-- Trending Tittle -->
          <div class="about-right mb-90">
            <div class="section-tittle mb-30 pt-30">
              <h3 style="text-align: center;">
                BẢO VỆ QUYỀN, LỢI ÍCH HỢP PHÁP CỦA NGƯỜI TRÚNG ĐẤU GIÁ VÀ KẾT QUẢ CỦA ĐẤU GIÁ BẰNG HÌNH THỨC ĐẤU GIÁ
                TRỰC TUYẾN
              </h3>
            </div>
            <div class="about-prea" style="text-align: justify;">
              <p class="about-pera1">
                Đấu giá trực tuyến là một trong số những hình thức đấu giá được quy định tại Khoản 1 Điều 40 Luật đấu
                giá tài sản. Do đó, quyền và lợi ích hợp pháp của người mua được tài sản bán đấu giá luôn được pháp luật
                về đấu giá tài sản bảo vệ. Trong hoạt động đấu giá tài sản, Đấu giá viên đóng vai trò như một “Thẩm phán
                phòng ngừa” rủi ro pháp lý. Trước khi đưa tài sản ra đấu giá, Đấu giá viên có trách nhiệm kiểm tra hồ sơ
                pháp lý và các tài liệu, thông tin về tài sản do người có tài sản đấu giá cung cấp và thông báo đầy đủ,
                chính xác cho người tham gia đấu giá. Khi thực hiện đấu giá, Đấu giá viên phải tuân thủ chặt chẽ các
                nguyên tắc, quy định của pháp luật về đấu giá tài sản và các quy định pháp luật khác có liên quan. Điều
                7 Luật đấu giá tài sản 2016 quy định về Bảo vệ quyền, lợi ích hợp pháp của người có tài sản đấu giá,
                người tham gia đấu giá, người trúng đấu giá, người mua được tài sản đấu giá ngay tình như sau:
              </p>
              <p class="about-pera1">
                1. Cơ quan nhà nước có thẩm quyền trong phạm vi nhiệm vụ, quyền hạn của mình có trách nhiệm bảo đảm việc
                thực hiện quyền, lợi ích hợp pháp của người có tài sản đấu giá, người tham gia đấu giá, người trúng đấu
                giá, người mua được tài sản đấu giá ngay tình.
              </p>
              <p class="about-pera1">
                2. Trường hợp có người thứ ba tranh chấp về quyền sở hữu đối với tài sản đấu giá thì quyền sở hữu vẫn
                thuộc về người mua được tài sản đấu giá ngay tình.
              </p>
              <p class="about-pera1">
                Việc giải quyết tranh chấp về quyền sở hữu đối với tài sản đấu giá, khiếu nại, khởi kiện về hiệu lực
                pháp lý của phiên đấu giá thành, việc hủy kết quả đấu giá tài sản quy định tại các khoản 2, 3 và 4 Điều
                72 của Luật này được thực hiện theo thủ tục rút gọn của pháp luật tố tụng dân sự.
              </p>
              <p class="about-pera1">
                3. Trường hợp có bản án, quyết định của cơ quan nhà nước có thẩm quyền về việc sửa đổi một phần hoặc hủy
                bỏ toàn bộ các quyết định liên quan đến tài sản đấu giá trước khi tài sản được đưa ra đấu giá nhưng
                trình tự, thủ tục đấu giá tài sản bảo đảm tuân theo quy định của Luật này thì tài sản đó vẫn thuộc quyền
                sở hữu của người mua được tài sản đấu giá ngay tình, trừ trường hợp kết quả đấu giá tài sản bị hủy theo
                quy định tại Điều 72 của Luật này.
              </p>
              <p class="about-pera1">
                Sau khi được Đấu giá viên tuyên bố là trúng đấu giá tài sản và hoàn thành nghĩa vụ thanh toán toàn bộ
                tiền mua tài sản, người trúng đấu giá được Đấu giá viên xác nhận trúng đấu giá thông qua Biên bản cuộc
                bán đấu giá, ký kết hợp đồng mua bán tài sản đấu giá hoặc được cơ quan có thẩm quyền phê duyệt kết quả
                đấu giá tài sản và được bàn giao hồ sơ pháp lý của tài sản.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';
export default {
  name: 'About',
  mixins: [mixin],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/News/4.vue